import { render, staticRenderFns } from "./GroupsIndex.vue?vue&type=template&id=0532d3e8&"
import script from "./GroupsIndex.vue?vue&type=script&lang=js&"
export * from "./GroupsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports